import { Box, Grid, Text, useColorMode } from "theme-ui"
import ApprovedProjects from "./ApprovedProjects"
import TradesInsights from "./TradesInsights"
import { ResidentialAndCommercialProps } from "../../../../../types/dashboard.types"
import GeoInsights from "../GeographicInsights/GeoInsights"
import MapSkeleton from "../GeographicInsights/MapSkeleton"
import React from "react"

const ResidentialAndCommercial = ({ approvedProject, projectInsights, tradesDistribution, mapData, loading }: ResidentialAndCommercialProps) => {
    const [colorMode] = useColorMode();
    const bgGeographic = colorMode === 'light' ? "#ffffff" : "#2e354db8";
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#252b36";
    const titleHeader = colorMode === 'light' ? "#453521" : "#f8f9fa";
    return <Box>
        <Grid columns={[1, 1, 1, 2]} gap="20px">
            <Box sx={{ background: bgGeographic, p: "20px", borderRadius: "20px" }} >
                <Text sx={{ fontSize: "18px", fontWeight: 700, color: titleHeader }}>Geographic Insights</Text>
                <Box sx={{
                    background: bgDashboard,
                    boxShadow: '0px 0px 40px 0px rgba(209, 173, 138, 0.12)',
                    px: loading ? '0px' : '23px',
                    py: loading ? '0px' : '24px',
                    borderRadius: '20px',
                    mt: 2,
                    height: loading ? '250px' : ['250px', '250px', '350px', '500px'],
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {loading ?
                        <MapSkeleton height={500} /> :
                        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                            <Text sx={{ fontSize: "16px", fontWeight: 600, color: colorMode === 'light' ? '#453521' : '#f8f9fab5', mb: 2 }}>Approved Projects by State</Text>
                            <Box style={{
                                flex: 1,
                                width: '100%',
                                minHeight: 0,
                                display: 'flex',
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: 'hidden'
                            }}>
                                <GeoInsights mapData={mapData} colorMode={colorMode} />
                            </Box>
                        </Box>
                    }
                </Box>
            </Box>
            <Box>
                <Box sx={{ display: "flex", flexDirection: ["column", "column", "column", "row"], gap: "20px", }}>
                    <Box sx={{ background: bgGeographic, p: "20px", borderRadius: "20px", width: "100%" }}>
                        <Text as="h6" sx={{ fontSize: ["10px", "12px", "14px", "18px"], fontWeight: 700, mb: "20px", color: titleHeader }}>
                            Type of project distribution
                        </Text>
                        <Box sx={{ display: "flex", flexDirection: ["column", "column", "row", "row"], gap: "20px", width: "100%", }}>
                            <Box sx={{ width: "100%" }}>
                                <ApprovedProjects data={approvedProject} loading={loading} colorMode={colorMode} />
                            </Box>
                            <Box sx={{ width: "100%" }}>
                                <TradesInsights projectInsights={projectInsights} loading={loading} colorMode={colorMode} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Grid>
    </Box>
}

export default React.memo(ResidentialAndCommercial)